import types, { ActionCreators } from './types';

const clearCSVUploadState: ActionCreators['ClearCSVUploadState'] = () => ({
  type: types.CLEAR_CSV_UPLOAD_STATE,
});

export const actions = {
  clearCSVUploadState,
};
